function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import Logos from "segments/desktop/core-components/logos/logos";
import { StyledAllLogosLogosComponent } from "./all-logos-logos-component.scss";
class AllLogosLogosComponent extends PureComponent {
    render() {
        const { logosAdvancedProps } = this.props;
        return /*#__PURE__*/ _jsx(StyledAllLogosLogosComponent, {
            className: "all-logos-logos-component",
            children: /*#__PURE__*/ _jsx(Logos, _object_spread({
                showAllLogos: true
            }, logosAdvancedProps))
        });
    }
}
export { AllLogosLogosComponent as default };
AllLogosLogosComponent.defaultProps = {
    paddingTop: "68px",
    paddingBottom: "68px",
    mobilePaddingTop: "24px",
    mobilePaddingBottom: "24px"
};
